import RouteModel from "../../model-factory/basic/route/RouteModel";
import {RouteKey, FactoryID} from "../../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../../model-factory/basic/route/RouteFactory";

export class EndRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "end_route_id";
}

export default class EndRouteFactory extends RouteFactory
{

    id: FactoryID = "end_route";

    constructor()
    {
        super();


        this.choices = {
        }
    }

    birth(id: FactoryID): EndRouteModel
    {
        return new EndRouteModel(id);
    }
}